const ITEMS = [
  "Ideias estratégicas",
  "Tecnologia",
  "Automação",
  "Inteligência Artificial",
  "Resultados",
];

export const Marquee = () => (
  <div
    className="relative overflow-hidden border-y border-white/5 bg-[#080b11]/80 py-6 select-none"
    aria-hidden="true"
    data-testid="editorial-marquee"
  >
    <div className="marquee-track flex w-max items-center gap-10">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center gap-10">
          {ITEMS.map((item) => (
            <span key={`${copy}-${item}`} className="flex items-center gap-10">
              <span className="whitespace-nowrap text-sm font-extralight uppercase tracking-[0.45em] text-slate-500">
                {item}
              </span>
              <span className="h-1.5 w-1.5 rotate-45 bg-[#007BFF]" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
